<template>
  <div :style="`${'height: 100%; background-color: '+backgroundColor}`">
    <div class="cmp-handle" style="z-index:999">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="settingVisible=true"
                            style="text-align: center">设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="editSignalName"
                            style="text-align: center">重命名
          </el-dropdown-item>
          <el-dropdown-item @click.native="select()"
                            style="text-align: center">{{selcted ? '取消选中' : '选中'}}
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-tooltip :content="uDataSources.length>0 ? uDataSources[0].text : '信号名'" placement="top-start" :open-delay="1000">
      <p v-show="!edit" @dblclick="(event)=>dbClick(event,uDataSources[0].key)"
         :style="`${'cursor: pointer; font-size: '+fontSize +'px;color: '+fontColor}`">{{uDataSources.length>0 ? uDataSources[0].text : '信号名'}}</p>
    </el-tooltip>
    <el-input v-if="edit" v-model="uDataSources[0].text"
              size="mini" @keyup.enter.native="saveControlName">
    </el-input>
    <div
        @dblclick="dbClickSetting"
        @click="(event)=>clickSelect(event)"
        @dragover="allowSingleBind"
        @drop="(event) => dragToSingleOutputCmp(event, componentIndex)">
      <el-tag :size="size" effect="plain" :type="type"
              style="cursor: pointer; width: 90%;text-align: center">{{uDataSources.length>0 ? uDataSources[0].value : 0}}</el-tag>
    </div>
    <el-dialog
        :append-to-body="true"
        :visible.sync="settingVisible"
        title="设置"
        width="30%">
      <el-row>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">字体大小</span>
          <el-input-number size="mini" v-model="exampleFontSize" :min="12" :max="30" controls-position="right" style="width: 80%"></el-input-number>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">颜色</span>
          <el-color-picker size="mini" v-model="exampleFontColor" show-alpha></el-color-picker>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <span :style="`${'font-size: '+exampleFontSize +'px;color: '+exampleFontColor}`">信号名</span>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">显示框大小</span>
          <el-select v-model="exampleSize" placeholder="请选择" style="width: 80%" size="small">
            <el-option
                v-for="item in sizeOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">显示框样式</span>
          <el-select v-model="exampleType" placeholder="请选择" style="width: 80%" size="small">
            <el-option
                v-for="item in typeOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <el-tag :size="exampleSize" :type="exampleType">30</el-tag>
        </el-col>
      </el-row>
      <span class="dialog-footer" slot="footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button @click="settingVisible = false,saveIndicatorConfig()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'NumericIndicator',
  props: {
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
    componentIndex: {
      type: Number,
    },
  },
  data() {
    return {
      uDataSources: [],
      edit: false,
      settingVisible: false,
      size: 'mini',
      exampleSize: 'mini',
      fontColor: '#303133',
      exampleFontColor: '#303133',
      fontSize: 15,
      exampleFontSize: 15,
      type: '',
      exampleType: '',
      sizeOptions: [
        { label: 'Large', value: '' },
        { label: 'Medium', value: 'medium' },
        { label: 'Small', value: 'small' },
        { label: 'Mini', value: 'mini' },
      ],
      typeOptions: [
        { label: 'Common', value: '' },
        { label: 'Success', value: 'success' },
        { label: 'Info', value: 'info' },
        { label: 'Warning', value: 'warning' },
        { label: 'Danger', value: 'danger' },
      ],
    };
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['addSignalToIndicator', 'setAnchorKeyWord', 'setAnchorPointId', 'selectCpt']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    select() {
      const id = this.itemData.cid;
      this.selectCpt(id);
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    allowSingleBind(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL || this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    dragToSingleOutputCmp(event, componentIndex) {
      // if (this.getCurCmpStatus) {
      //   this.$message({
      //     message: '当前面板正在运行，请先进行关闭',
      //   });
      //   return;
      // }
      // const isExistIndex = this.uDataSources.findIndex(item2 => item2.key === this.dragTreeNodeKey);
      // if (isExistIndex > -1) {
      //   this.$message({
      //     message: '无法拖拽重复的节点',
      //   });
      //   return;
      // }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      this.addSignalToIndicator({ dragNode, componentIndex });
    },
    editSignalName() {
      if (this.uDataSources.length > 0) {
        this.edit = true;
      } else {
        this.$message({
          message: '请先绑定信号！',
          type: 'warning',
        });
      }
    },
    async saveIndicatorConfig() {
      this.size = this.exampleSize;
      this.type = this.exampleType;
      this.fontSize = this.exampleFontSize;
      this.fontColor = this.exampleFontColor;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentStyleParams = [];
      const componentStyleParam = {
        componentId: this.itemData.cid,
        wordSize: this.fontSize,
        wordColor: this.fontColor,
        componentSize: this.size,
      };
      componentStyleParams.push(componentStyleParam);
      console.log({ projectId, panelId, componentStyleParams });
      await projectDetailAPI.saveCptStyle(projectId, panelId, componentStyleParams)
        .catch((err) => {
          this.$message.error('保存失败！');
        });
    },
    async saveControlName() {
      this.edit = false;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentId = this.itemData.cid;
      const signalKey = this.uDataSources[0].key;
      const name = this.uDataSources[0].text;
      console.log({ projectId, panelId, componentId, signalKey, name });
      await projectDetailAPI.saveCptName(projectId, panelId, componentId, signalKey, name)
        .catch((err) => {
          this.$message.error('信号名保存失败！');
        });
    },
    clickSelect(event) {
      if (event.ctrlKey) {
        this.select();
      }
    },
    dbClickSetting() {
      this.settingVisible = true;
    },
  },
  // 以下代码日后可优化
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    ...mapState('Engineering', ['dragTreeNodeType']),
    chartData() {
      return this.itemData.chartData || [];
    },
    styleSetting() {
      return this.itemData.styleSetting || [];
    },
    dataSou() {
      return this.itemData.dataSources || [];
    },
    // styleKey() {
    //   return this.$store.state.Engineering.styleKey;
    // },
    selcted() {
      const id = this.itemData.cid;
      if (this.$store.state.Engineering.selectedCpts.indexOf(id) > -1) {
        return true;
      }
      return false;
    },
    backgroundColor() {
      if (this.selcted) {
        return 'rgba(127,204,232,0.21)';
      }
      return '';
    },
  },
  watch: {
    dataSou: {
      handler(newDataSou) {
        const self = this;
        self.uDataSources = newDataSou.map(item => ({
          text: item.text,
          key: item.key,
          value: 0,
        }));
      },
      deep: true,
      immediate: true,
    },
    chartData: {
      handler(newChartData = []) {
        const self = this;
        const { uDataSources } = this;
        if (newChartData.length > 0) {
          newChartData.forEach((item) => {
            const index = uDataSources.findIndex(item2 => item2.key === item.key);
            if (index > -1) {
              self.uDataSources[index].value = item.values[0].value;
            }
          });
        }
      },
      immediate: true,
      deep: true,
    },
    // 由0改为setting.length-1，待优化
    styleSetting: {
      handler(setting) {
        const self = this;
        if (setting.length > 0) {
          self.size = setting[setting.length - 1].size;
          self.fontSize = setting[setting.length - 1].fontSize;
          self.fontColor = setting[setting.length - 1].fontColor;
        }
      },
      deep: true,
      immediate: true,
    },
    // styleKey() {
    //   if (this.itemData.setting !== undefined) {
    //     this.size = this.itemData.setting.size;
    //     this.fontSize = this.itemData.setting.fontSize;
    //     this.fontColor = this.itemData.setting.fontColor;
    //   }
    // },
  },
};
</script>

<style scoped>
  .el-input__icon {
    line-height: 25px;
    opacity:0;
  }
  .cmp-handle {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/NumericIndicator.vue